import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import airbridge from 'airbridge-web-sdk-loader'
const root = ReactDOM.createRoot(document.getElementById('root'));
airbridge.init({
    app: 'chips',
    webToken: '51376e0701ce4ce5b815803c243f610e',
})
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
